export default {
    list: {
        title: 'Receivers',
        subtitle: 'Manage your receiver accounts',
        invite: 'Invite Receiver',
        loading: 'Loading receivers...',
        searchPlaceholder: 'Search by name or email...',
        statusPlaceholder: 'Filter by status',
        countryPlaceholder: 'Filter by country',
        description: 'List of receivers you collaborate with',
        headers: {
            company: 'Company',
            country: 'Country',
            email: 'Email',
            status: 'Status',
            activeContainers: 'Active Containers',
            totalContainers: 'Total Containers',
            lastContainer: 'Last Container',
            inviteDate: 'Invite Date',
            actions: 'Actions',
        },
        noReceivers: {
            title: 'No receivers found',
            message: 'Try modifying the search filters',
            emptyMessage: 'Start by inviting your first receiver',
            inviteFirst: 'Invite First Receiver',
        },
        modal: {
            title: 'Invite Receiver',
            selectReceiver: 'Select Receiver',
            selectReceiverPlaceholder: 'Choose a receiver...',
            notes: 'Notes (optional)',
            notesPlaceholder: 'Add a note for the receiver...',
            selectedReceiver: 'Selected Receiver',
            name: 'Name',
            email: 'Email',
            country: 'Country',
            cancel: 'Cancel',
            sendInvite: 'Send Invite',
            mode: {
                email: 'Manual Email',
                addressBook: 'Address Book',
            },
            emailLabel: 'Email Address',
            emailPlaceholder: 'Enter the receiver\'s email address',
            emailHint: 'The receiver will be added to the system when they accept the invite',
            selectFromAddressBook: 'Select from Address Book',
            selectAddressBookPlaceholder: 'Choose a contact from address book...',
            selectedInfo: 'Selected Information',
            role: 'Role',
        },
        actions: {
            viewDetails: 'View Details',
            suspend: 'Suspend Collaboration',
            delete: 'Delete Collaboration',
        },
        confirmSuspend: 'Are you sure you want to suspend this collaboration?',
        confirmDelete: 'Are you sure you want to delete this collaboration?',
        none: 'None',
        allStatuses: 'All statuses',
        allCountries: 'All countries',
    },
    detail: {
        loading: 'Loading receiver details...',
        backToList: 'Back to List',
        notFound: {
            title: 'Receiver not found',
            message: 'The selected receiver does not exist.',
        },
        info: {
            companyInfo: 'Company Information',
            containerStats: 'Container Statistics',
            fields: {
                legalName: 'Legal Name',
                entityType: 'Entity Type',
                taxId: 'Tax ID',
                country: 'Country',
                address: 'Address',
                email: 'Email',
                phone: 'Phone',
                eta: 'ETA',
            },
            stats: {
                total: 'Total',
                inTransit: 'In Transit',
                delivered: 'Delivered',
                delayed: 'Delayed',
                pendingDocuments: 'Pending Documents',
                highRisk: 'High Risk',
            },
        },
        containers: {
            title: 'Containers',
            count: 'of',
            searchPlaceholder: 'Search containers...',
            statusPlaceholder: 'Filter by status',
            riskPlaceholder: 'Filter by risk',
            documentsPlaceholder: 'Filter by documents',
            headers: {
                containerId: 'Container Ref.',
                route: 'Route',
                progress: 'Progress',
                eta: 'ETA',
                status: 'Status',
                docStatus: 'Document Status',
                riskLevel: 'Risk Level',
                value: 'Value',
                actions: 'Actions',
            },
            noContainers: {
                title: 'No containers found',
                message: 'Try modifying the search filters',
                emptyMessage: 'There are no containers for this receiver',
            },
        },
    },
};

